(function() {

var _ = ui._;
var $box, $count, $footer, $message, $messageBox, $messages, $typing, $window;
var audio;
var chatWindowShow = false;
var chatWindowIsVisible = false;
var lastDate = 0;
var notReadMessageIDs = [];
var typingIndex = 0;
var typingInterval = 0;
var typingStart = 0;
var webSocket;
var wsErrorFired = false;
var wsErrorTimer;

var isIOS = navigator.userAgentData && navigator.userAgentData.platform
  ? ['ios', 'ipad', 'ipod'].indexOf(navigator.userAgentData.platform.toLowerCase()) !== -1
  : /iPhone|iPad|iPod/i.test(navigator.userAgent);

var isMobile = navigator.userAgentData && (navigator.userAgentData.mobile !== undefined)
  ? navigator.userAgentData.mobile
  : isIOS || /Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

ui.chatHide = chatHide;
ui.chatMessageClose = chatMessageClose;
ui.chatOpen = chatOpen;
ui.chatOpenEx = chatOpenEx;
ui.chatOnInput = onInput;
ui.chatMessageSend = messageSend;
ui.typingAnimate = typingAnimate;

ui.afterSessionInitAdd(onLoad);
d.addEventListener('visibilitychange', messagesReadSend);

function onLoad() {
  $box = _('div').appendTo(_(d.body)).attr('class', 'chat-main-btn').append(
    $count = _('div').attr('class', 'hidden chat-main-count-not-read').text(0),
    _('span').attr('class', 'chat-main-img', 'onclick', 'ui.chatOpen(event)').append(
      _('svg').attr('class', 'chat-main-img-img').append(
         _('use').attr('href', '#svg-icon-chat')
       )
    )
   );

  if(ui.lang.chat_message) {
    $messageBox = _('div').appendTo($box).attr('class', 'chat-main-message-box').append(
      _('div').text(ui.lang.chat_message),
      _('div').attr('class', 'chat-message-close-box', 'onclick', 'ui.chatMessageClose(event)').append(
        _('i').attr('class', 'fa fa-times-circle-o')
      )
    );
    setTimeout(chatMessageClose, 10000);
  }

  if(ui.session_data.chat_connect)
    chatOpen();
}

function beep() {
  if(!audio) {
    audio = new Audio('/image/sound/notification-c.mp3')
    audio.volume = 0.3;
  }
  audio.play();
}

function chatCreate() {
  var $btns;
  $window = _('div').appendTo($box).attr('class', 'chat-window').append(
    _('div').attr('class', 'chat-header').append(
      $btns = _('span').attr('class', 'chat-btns'),
      _('span').attr('class', 'chat-title').text(ui.lang.text_chat),
      _('span').attr('class', 'chat-close-btn', 'onclick', 'ui.chatHide(event)').html('&#10006;')
    ),
    $messages = _('div').attr('class', 'chat-messages'),
    $footer = _('div').attr('class', 'chat-footer').append(
      $message = _('span').attr('class', 'chat-footer-message', 'title', ui.lang.text_enter_message, 'contenteditable', 'true', 'onkeydown', 'ui.chatOnInput(event)'),
      _('span').attr('class', 'fa fa-send chat-footer-btn', 'onclick', 'ui.chatMessageSend(event)')
    )
  );

  if(ui.chat) {
    var names = Object.keys(ui.chat), name;
    for(var i = 0; i < names.length; i++) {
      name = names[i];
      $btns.prepend(
        _('span').attr('class', 'chat-ex-btn fa fa-' + name, 'onclick', "ui.chatOpenEx(event, '" + name + "')")
      );
    }
  }
}

function chatHide(event) {
  messageNewSignDestroy();
  $window && $window.toggleClass('hidden', true);
  chatWindowIsVisible = false;
}

function chatMessageClose(event) {
  event && event.preventDefault();
  $messageBox.toggleClass('hidden', true);
}

function chatOpen(event) {
  if(event)
    event.preventDefault();
  chatWindowShow = !!event;
  if(!webSocket || ([WebSocket.OPEN, WebSocket.CONNECTING].indexOf(webSocket.readyState) === -1)) {
    webSocket           = new WebSocket('wss://chat.besport.ua/');
    webSocket.onmessage = onWSMessage;
    webSocket.onopen    = onWSOpen;
    webSocket.onclose   = onWSClose;
    webSocket.onerror   = onWSError;
  } else
    chatShow();
}

function chatOpenEx(event, name) {
  event.preventDefault();
  var ident = ui.chat[name];
  var url = '';
  switch (name) {
  case 'instagram':
    /*if(isMobile)
      location.href = 'instagram://user?username=' + encodeURIComponent(ident)
    else*/
      url = 'https://www.instagram.com/' + encodeURIComponent(ident);
    break;
  case 'messenger':
    /*if(isMobile)
      location.href = 'fb-messenger://user' + (isIOS ? '-thread/' : '/') + ident;
    else
      url = 'https://www.messenger.com/t/' + ident;*/
    url = 'https://m.me/' + encodeURIComponent(ident);
    break;
  case 'telegram':
    url = 'https://t.me/' + encodeURIComponent(ident);
    break;
  case 'viber':
    /*if(isMobile)
      url = 'viber://pa/chatURI=%2B' + encodeURIComponent(ident);
    else*/
      url = 'viber://chat?number=' + encodeURIComponent(ident);
      //url = 'viber://pa?chatURI=' + encodeURIComponent(ident);
    break;
  case 'whatsapp':
    url = (isMobile ? 'https://wa.me/' : 'https://web.whatsapp.com/send?phone=') + ident;
    break;
  default:
    return;
  }
  if(url)
    w.open(url, '_blank', 'noopener');
}

function chatShow() {
  if(!$window)
    chatCreate();
  $window.toggleClass('hidden', !chatWindowShow);
  chatWindowIsVisible = chatWindowShow;
  chatWindowShow = false;
  notWorkingMessageAdd();
  messageScroll();
  if(chatWindowIsVisible)
    $message.el.focus();
}

function messagePrepare(message) {
  message = '' + message;
  var pos = message.lastIndexOf('https://'), posTo, c, i, href;
  while(pos >= 0) {
    posTo = message.length;
    for(i = pos; i < message.length; i++) {
      c = message.charAt(i);
      if([' ', '\n'].indexOf(c) !== -1) {
        posTo = i;
        break;
      }
    }

    href = message.substring(pos, posTo);

    message = message.substring(0, pos) + '<a target="_blank" href="' + href + '">' + href + '</a>' + message.substring(posTo);

    pos = message.lastIndexOf('https://', pos - 1);
  }
  return message;
}

function messageScroll() {
  if(!chatWindowIsVisible)
    return;
  var $sign = _('#chat-new-messages-sign');
  if($sign.el)
    $sign.scrollIntoView();
  else
    $messages.el.scrollTo(0, $messages.el.scrollHeight);
  messagesReadSend();
}

function messageShow(message) {
  _('#chat-message-' + message.message_id).remove();
  var date = new Date(message.date * 1000);
  var dateS = formatDate(date);
  if(lastDate !== dateS) {
    lastDate = dateS;
    $messages.append(
      _('div').attr('class', 'chat-message-box text-center').append(
        _('div').attr('class', 'chat-message-date').text(dateS)
      )
    );
  }

  return _('div').attr('class', 'chat-message-box' + (message.type_id === 0 ? '' : ' text-right'), 'id', 'chat-message-' + message.message_id).appendTo($messages).append(
    _('div').attr('class', 'chat-message').append(
      (message.type_id === 0 ? _('div').attr('class', 'chat-user-name').text(ui.lang.text_manager) : null),
      _('div').attr('class', 'chat-message-body').html(messagePrepare(message.message)),
      _('div').attr('class', 'chat-message-time').text(formatTime(date)).append(
        (message.type_id === 0 ? null : _('span').attr('id', 'cms-' + message.message_id, 'class', 'chat-message-status chat-message-status-' + message.status_id))
      )
    )
  );
}

function messageSend() {
  var text = $message.textGet();
  if(!text)
    return;
  var date = now();
  $message.text('');
  var message = {type_id: 1, status_id: 0, date: date, message: text, message_id: 0};
  var $messageNew = messageShow(message);
  notWorkingMessageAdd();
  messageNewSignDestroy();
  $messageNew.scrollIntoView();
  webSocket.send(JSON.stringify({type: 'messageAdd', date: date, message: text}));
}

function messageNew(message) {
  messageNewSignCreate();
  messageShow(message);
  notReadMessageIDs.push(message.message_id);
  messageNotReadCountShow();
  messageScroll();
}

function messageNewSignCreate() {
  var $sign = _('#chat-new-messages-sign');
  if(!$sign.el)
    $messages.append(
      _('div').attr('class', 'chat-new-messages-sign', 'id', 'chat-new-messages-sign').text(ui.lang.text_chat_new_messages)
    );
}

function messageNewSignDestroy() {
  _('#chat-new-messages-sign').remove();
}

function messageNotReadCountShow() {
  var exists = notReadMessageIDs.length > 0;
  $count && $count.toggleClass('hidden', !exists).text(notReadMessageIDs.length);
  if(exists)
    beep();
}

function messagesReadSend() {
  messageNotReadCountShow();
  if(!chatWindowIsVisible || (notReadMessageIDs.length === 0) || (d.visibilityState !== 'visible'))
    return;
  webSocket.send(JSON.stringify({type: 'messagesRead', message_ids: notReadMessageIDs}));
  notReadMessageIDs = [];
}

function messagesShow(messages) {
  notReadMessageIDs = [];
  for(var i = 0, l = messages.length; i < l; i++) {
    if((messages[i].type_id === 0) && (messages[i].status_id !== 2)) {
      if(notReadMessageIDs.length === 0)
        messageNewSignCreate();
      notReadMessageIDs.push(messages[i].message_id);
    }
    messageShow(messages[i]);
  }
  if((messages.length === 0) && workingTimeCalc())
    messageShow({
      date: now(),
      message: ui.lang.text_chat_greetings,
      message_id: 'a',
      type_id: 0
    });
  notWorkingMessageAdd();
  messageNotReadCountShow();
  messageScroll();
}

function notWorkingMessageAdd() {
  if(workingTimeCalc())
    return;
  messageShow({
    date: now(),
    message: ui.lang.text_chat_not_working_time,
    message_id: 'nw',
    type_id: 0
  });
}

function now() {
  return Math.ceil((new Date).valueOf() / 1000);
}

function typingAnimate() {
  if(!$typing)
    $typing = _('div').appendTo($footer).attr('class', 'chat-message-typing hidden').text(ui.lang.text_manager + ' ' + ui.lang.text_chat_typing).append(
      _('span').attr('class', 'chat-dot chat-dot-0').text(' .'),
      _('span').attr('class', 'chat-dot chat-dot-1').text(' .'),
      _('span').attr('class', 'chat-dot chat-dot-2').text(' .')
    );
  typingStart = (new Date).valueOf();
  if(!typingInterval) {
    typingIndex = 0;
    $typing.attr('class', 'chat-message-typing chat-message-typing-' + typingIndex);
    typingInterval = setInterval(typingAnimateRun, 800);
  }
}

function typingAnimateRun() {
  var now = (new Date).valueOf();
  if(now - typingStart > 5000) {
    $typing.toggleClass('hidden', true);
    clearInterval(typingInterval);
    typingInterval = 0;
    return;
  }
  $typing.toggleClass('chat-message-typing-' + typingIndex, false);
  typingIndex = typingIndex === 2 ? 0 : typingIndex + 1;
  $typing.toggleClass('chat-message-typing-' + typingIndex, true);
}

function workingTimeCalc() {
  var now = new Date(new Date().toLocaleString('en-US', {timeZone: 'Europe/Kyiv'}));
  var hour = now.getHours();
  var day = now.getDay();
  return (hour >= 9) && (hour < 18) && (day >= 1) && (day <= 5);
}

function onInput(event) {
  if(event.keyCode === 13) {
    event.preventDefault();
    messageSend();
  }
}

function onWSClose(event) {
  chatHide();
  $box.toggleClass('chat-main-btn-active', false);
  if(!event.wasClean && !wsErrorFired && ui.session_data.chat_connect)
    chatOpen();
}

function onWSError(event) {
  wsErrorFired = true;
  ui.messageShow(ui.lang.text_chat_server_disconnected, 'error');
  if(wsErrorTimer)
    clearTimeout(wsErrorTimer);
  if(ui.session_data.chat_connect)
    wsErrorTimer = setTimeout(chatOpen, 20000);
}

function onWSMessage(event) {
  var data = JSON.parse(event.data);
  if(data.type === 'status') {
    _('#chat-message-0').attr('id', 'chat-message-' + data.message_id);
    _('#cms-0').attr('id', 'cms-' + data.message_id, 'class', 'chat-message-status chat-message-status-' + data.status_id);
  } else if(data.type === 'statuses') {
    for(var i = 0; i < data.message_ids.length; i++)
      _('#cms-' + data.message_ids[i]).attr('class', 'chat-message-status chat-message-status-' + data.status_id);
  } else if(data.type === 'messages') {
    messagesShow(data.messages);
  } else if(data.type === 'messageNew') {
    typingStart = 0;
    messageNew(data);
  } else if(data.type === 'lock') {
    typingAnimate();
  } else
    console.error('onMessage: not handled type ' + data.type);
}

function onWSOpen(event) {
  wsErrorFired = false;
  webSocket.send(JSON.stringify({type: 'chatInit', session_id: ui.session_data.session_id, 'store_id': ui.store_id, 'url': location.href}));
  chatShow();
  $box.toggleClass('chat-main-btn-active', true);
  if(wsErrorTimer) {
    clearTimeout(wsErrorTimer);
    wsErrorTimer = null;
  }
}

function format2(int) {
  return (int < 10 ? '0' : '') + int;
}

function formatDate(dt) {
  var options = {month: 'long', day: 'numeric'};
  if((new Date).getYear() !== dt.getYear())
    options.year = '2-digit';
  return dt.toLocaleDateString(undefined, options);
}

function formatTime(dt) {
  return dt.getHours() + ':' + format2(dt.getMinutes());
}

})();